export default __webpack_public_path__ + "static/media/platform_live_and_playback.b6008671.svg";